module.exports = __webpack_public_path__ + "static/etapes_livraison-4a161d31c62fa49fa851dd62100fb1bb.png";